var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"imprint"},[_c('h1',[_vm._v(_vm._s(_vm.$t('imprint')))]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('address'))}}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('projectgroup'))}}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('contact'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }